// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .hero-section {
    background: linear-gradient(to right, #2563eb, #4f46e5);
    color: white;
    padding: 5rem 1rem;
    text-align: center;
  }
  
  .hero-content {
    max-width: 1200px;
    margin: 0 auto;
  }
  


  .hero-title {
    font-size: 2.25rem; 
    font-weight: 800;
    margin-bottom: 1.5rem;
    letter-spacing: -0.025em;
    line-height: 1.2; 
  }
  
  .hero-title-accent {
    color: #fbbf24;
  }
  
  .hero-subtitle {
    font-size: 1.5rem;
    max-width: 800px;
    margin: 0 auto 3rem;
    line-height: 1.5;
    font-weight: 400;
  }
  
  .search-container {
    max-width: 700px;
    margin: 0 auto;
  }
  
  .search-wrapper {
    background: linear-gradient(to right, #f59e0b, #f97316);
    padding: 4px;
    border-radius: 12px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
  }
  
  .search-form {
    display: flex;
    flex-direction: column;
  }
  
  .search-input {
    padding: 1.25rem 1.5rem;
    font-size: 1.1rem;
    border: none;
    width: 100%;
    font-family: 'Poppins', sans-serif;
    text-align: center;
  }
  
  .search-button {
    background: linear-gradient(to right, #2563eb, #4f46e5);
    color: white;
    font-weight: 600;
    font-size: 1.1rem;
    padding: 1.25rem 2rem;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    font-family: 'Poppins', sans-serif;
  }
  
  .search-button:hover {
    background: linear-gradient(to right, #1d4ed8, #4338ca);
    transform: translateY(-2px);
  }
  
  .popular-searches {
    margin-top: 1.5rem;
    color: #bfdbfe;
    font-size: 1.05rem;
  }
  
  @media (min-width: 768px) {
    .hero-section {
      padding: 7rem 1rem;
    }
    
    .hero-title {
      font-size: 2.75rem;
    }
    
    .search-form {
      flex-direction: row;
    }
    
    .search-input {
      flex: 1;
      border-radius: 8px 0 0 8px;
    }
    
    .search-button {
      width: auto;
      border-radius: 0 8px 8px 0;
    }
  }



 */



 .hero-section {
  background: linear-gradient(to right, #2563eb, #4f46e5);
  color: white;
  padding: 5rem 1rem;
  text-align: center;
}

.hero-content {
  max-width: 1200px;
  margin: 0 auto;
}

.hero-title {
  font-size: 2.25rem;
  font-weight: 800;
  margin-bottom: 1.5rem;
  letter-spacing: -0.025em;
  line-height: 1.2;
}

.hero-title-accent {
  color: #fbbf24;
}

.hero-subtitle {
  font-size: 1.5rem;
  max-width: 800px;
  margin: 0 auto 3rem;
  line-height: 1.5;
  font-weight: 400;
}

.search-container {
  max-width: 700px;
  margin: 0 auto;
  position: relative;
}

.search-form {
  display: flex;
  flex-direction: column;
  position: relative;
}

.search-input-wrapper {
  position: relative;
  width: 100%;
}

.search-input {
  padding: 1.25rem 1.5rem;
  font-size: 1.1rem;
  border: none;
  width: 100%;
  font-family: 'Poppins', sans-serif;
  text-align: center;
  box-sizing: border-box;
}

.loading-spinner {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #2563eb;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: translateY(-50%) rotate(0deg); }
  100% { transform: translateY(-50%) rotate(360deg); }
}

.search-button {
  background: linear-gradient(to right, #2563eb, #4f46e5);
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
  padding: 1.25rem 2rem;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Poppins', sans-serif;
}

.search-button:hover {
  background: linear-gradient(to right, #1d4ed8, #4338ca);
  transform: translateY(-2px);
}

.suggestions-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  margin-top: 4px;
}

.suggestion-item {
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: background-color 0.2s ease;
  text-align: left;
}

.suggestion-item:hover {
  background-color: #f9fafb;
}

.suggestion-item:last-child {
  border-bottom: none;
}

.suggestion-name {
  font-weight: 500;
  color: #1f2937;
  margin-bottom: 0.25rem;
}

.suggestion-postcode {
  font-size: 0.875rem;
  color: #6b7280;
}

.error-message {
  color: #fef3c7;
  margin-top: 0.5rem;
  font-size: 0.875rem;
}

.popular-searches {
  margin-top: 1.5rem;
  color: #bfdbfe;
  font-size: 1.05rem;
}

@media (min-width: 768px) {
  .hero-section {
    padding: 7rem 1rem;
  }
  
  .hero-title {
    font-size: 2.75rem;
  }
  
  .search-form {
    flex-direction: row;
  }
  
  .search-input {
    flex: 1 1;
    border-radius: 8px 0 0 8px;
    text-align: left;
    padding-right: 3rem;
  }
  
  .search-button {
    width: auto;
    border-radius: 0 8px 8px 0;
  }

  .suggestions-dropdown {
    top: 100%;
    left: 0;
    right: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HeroSection.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA6GE;;;;CAID;EACC,uDAAuD;EACvD,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,wCAAwC,EAAE;EAC/C,OAAO,0CAA0C,EAAE;AACrD;;AAEA;EACE,uDAAuD;EACvD,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,uDAAuD;EACvD,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iFAAiF;EACjF,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gCAAgC;EAChC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,SAAS;IACT,OAAO;IACP,QAAQ;EACV;AACF","sourcesContent":["/* .hero-section {\n    background: linear-gradient(to right, #2563eb, #4f46e5);\n    color: white;\n    padding: 5rem 1rem;\n    text-align: center;\n  }\n  \n  .hero-content {\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n  \n\n\n  .hero-title {\n    font-size: 2.25rem; \n    font-weight: 800;\n    margin-bottom: 1.5rem;\n    letter-spacing: -0.025em;\n    line-height: 1.2; \n  }\n  \n  .hero-title-accent {\n    color: #fbbf24;\n  }\n  \n  .hero-subtitle {\n    font-size: 1.5rem;\n    max-width: 800px;\n    margin: 0 auto 3rem;\n    line-height: 1.5;\n    font-weight: 400;\n  }\n  \n  .search-container {\n    max-width: 700px;\n    margin: 0 auto;\n  }\n  \n  .search-wrapper {\n    background: linear-gradient(to right, #f59e0b, #f97316);\n    padding: 4px;\n    border-radius: 12px;\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);\n  }\n  \n  .search-form {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .search-input {\n    padding: 1.25rem 1.5rem;\n    font-size: 1.1rem;\n    border: none;\n    width: 100%;\n    font-family: 'Poppins', sans-serif;\n    text-align: center;\n  }\n  \n  .search-button {\n    background: linear-gradient(to right, #2563eb, #4f46e5);\n    color: white;\n    font-weight: 600;\n    font-size: 1.1rem;\n    padding: 1.25rem 2rem;\n    border: none;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-family: 'Poppins', sans-serif;\n  }\n  \n  .search-button:hover {\n    background: linear-gradient(to right, #1d4ed8, #4338ca);\n    transform: translateY(-2px);\n  }\n  \n  .popular-searches {\n    margin-top: 1.5rem;\n    color: #bfdbfe;\n    font-size: 1.05rem;\n  }\n  \n  @media (min-width: 768px) {\n    .hero-section {\n      padding: 7rem 1rem;\n    }\n    \n    .hero-title {\n      font-size: 2.75rem;\n    }\n    \n    .search-form {\n      flex-direction: row;\n    }\n    \n    .search-input {\n      flex: 1;\n      border-radius: 8px 0 0 8px;\n    }\n    \n    .search-button {\n      width: auto;\n      border-radius: 0 8px 8px 0;\n    }\n  }\n\n\n\n */\n\n\n\n .hero-section {\n  background: linear-gradient(to right, #2563eb, #4f46e5);\n  color: white;\n  padding: 5rem 1rem;\n  text-align: center;\n}\n\n.hero-content {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.hero-title {\n  font-size: 2.25rem;\n  font-weight: 800;\n  margin-bottom: 1.5rem;\n  letter-spacing: -0.025em;\n  line-height: 1.2;\n}\n\n.hero-title-accent {\n  color: #fbbf24;\n}\n\n.hero-subtitle {\n  font-size: 1.5rem;\n  max-width: 800px;\n  margin: 0 auto 3rem;\n  line-height: 1.5;\n  font-weight: 400;\n}\n\n.search-container {\n  max-width: 700px;\n  margin: 0 auto;\n  position: relative;\n}\n\n.search-form {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.search-input-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.search-input {\n  padding: 1.25rem 1.5rem;\n  font-size: 1.1rem;\n  border: none;\n  width: 100%;\n  font-family: 'Poppins', sans-serif;\n  text-align: center;\n  box-sizing: border-box;\n}\n\n.loading-spinner {\n  position: absolute;\n  right: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #2563eb;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: translateY(-50%) rotate(0deg); }\n  100% { transform: translateY(-50%) rotate(360deg); }\n}\n\n.search-button {\n  background: linear-gradient(to right, #2563eb, #4f46e5);\n  color: white;\n  font-weight: 600;\n  font-size: 1.1rem;\n  padding: 1.25rem 2rem;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: 'Poppins', sans-serif;\n}\n\n.search-button:hover {\n  background: linear-gradient(to right, #1d4ed8, #4338ca);\n  transform: translateY(-2px);\n}\n\n.suggestions-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 1000;\n  margin-top: 4px;\n}\n\n.suggestion-item {\n  padding: 0.75rem 1rem;\n  cursor: pointer;\n  border-bottom: 1px solid #f3f4f6;\n  transition: background-color 0.2s ease;\n  text-align: left;\n}\n\n.suggestion-item:hover {\n  background-color: #f9fafb;\n}\n\n.suggestion-item:last-child {\n  border-bottom: none;\n}\n\n.suggestion-name {\n  font-weight: 500;\n  color: #1f2937;\n  margin-bottom: 0.25rem;\n}\n\n.suggestion-postcode {\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n.error-message {\n  color: #fef3c7;\n  margin-top: 0.5rem;\n  font-size: 0.875rem;\n}\n\n.popular-searches {\n  margin-top: 1.5rem;\n  color: #bfdbfe;\n  font-size: 1.05rem;\n}\n\n@media (min-width: 768px) {\n  .hero-section {\n    padding: 7rem 1rem;\n  }\n  \n  .hero-title {\n    font-size: 2.75rem;\n  }\n  \n  .search-form {\n    flex-direction: row;\n  }\n  \n  .search-input {\n    flex: 1;\n    border-radius: 8px 0 0 8px;\n    text-align: left;\n    padding-right: 3rem;\n  }\n  \n  .search-button {\n    width: auto;\n    border-radius: 0 8px 8px 0;\n  }\n\n  .suggestions-dropdown {\n    top: 100%;\n    left: 0;\n    right: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
